import { render, staticRenderFns } from "./MainCarouselItem.vue?vue&type=template&id=67f72d2e&"
import script from "./MainCarouselItem.vue?vue&type=script&lang=js&"
export * from "./MainCarouselItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports